export default "__VITE_ASSET__Bws32uCm__"